import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const BlogDetailPage = () => {
  const { id } = useParams();

  // Blog yazıları verisi
  const blogPosts = [
    {
      id: '1',
      category: 'Astroloji',
      title: 'Doğum Haritanız Size Ne Anlatıyor?',
      excerpt: 'Doğum haritanız, kişiliğinizin derinliklerini ve yaşam yolculuğunuzun haritasını ortaya koyar.',
      date: '15 Aralık 2024',
      readTime: '5 dk',
      author: 'Deniz Erin',
      image: 'https://public.readdy.ai/ai/img_res/d2b024f711930c07b17d829130789403.jpg',
      content: `
        <p>Doğum haritanız, evrenin size sunduğu en kişisel ve benzersiz haritadır. Doğduğunuz an, gezegenlerin gökyüzündeki konumları, yıldızların dizilişi ve burçların enerjileri bir araya gelerek sizin ruhsal DNA'nızı oluşturur.</p>

        <h2>Doğum Haritası Nedir?</h2>
        <p>Doğum haritası, doğduğunuz tarih, saat ve yerdeki gök cisimlerinin konumlarını gösteren astrolojik bir haritadır. Bu harita, kişiliğinizin temel özelliklerini, yeteneklerinizi, zorluklarınızı ve yaşam amacınızı ortaya koyar.</p>

        <h2>Haritanızın Ana Bileşenleri</h2>
        <p><strong>Güneş Burcunuz:</strong> Temel kişiliğinizi, ego yapınızı ve yaşam enerjinizi temsil eder. Kendinizi nasıl ifade ettiğinizi ve dünyaya nasıl göründüğünüzü gösterir.</p>

        <p><strong>Ay Burcunuz:</strong> Duygusal dünyanızı, içsel ihtiyaçlarınızı ve bilinçaltı tepkilerinizi yansıtır. Kendinizi güvende hissetmek için neye ihtiyacınız olduğunu gösterir.</p>

        <p><strong>Yükselen Burcunuz:</strong> Dış dünyanın sizi nasıl algıladığını, ilk izleniminizi ve yaşam yaklaşımınızı belirler. Kişiliğinizin maskesi olarak düşünülebilir.</p>

        <h2>Evler ve Gezegen Konumları</h2>
        <p>Doğum haritanızdaki 12 ev, yaşamınızın farklı alanlarını temsil eder. Her evin içindeki gezegenler, o alanda nasıl deneyimler yaşayacağınızı gösterir:</p>

        <ul>
          <li><strong>1. Ev:</strong> Kişilik, fiziksel görünüm, yaşam yaklaşımı</li>
          <li><strong>2. Ev:</strong> Maddi değerler, kazanç, öz değer</li>
          <li><strong>3. Ev:</strong> İletişim, kardeşler, yakın çevre</li>
          <li><strong>4. Ev:</strong> Aile, yuva, kökenler, duygusal temel</li>
          <li><strong>5. Ev:</strong> Yaratıcılık, aşk, çocuklar, eğlence</li>
          <li><strong>6. Ev:</strong> Sağlık, günlük rutinler, hizmet</li>
          <li><strong>7. Ev:</strong> İlişkiler, ortaklıklar, evlilik</li>
          <li><strong>8. Ev:</strong> Dönüşüm, paylaşılan kaynaklar, derinlik</li>
          <li><strong>9. Ev:</strong> Felsefe, yüksek öğrenim, uzak yolculuklar</li>
          <li><strong>10. Ev:</strong> Kariyer, toplumsal statü, yaşam amacı</li>
          <li><strong>11. Ev:</strong> Arkadaşlıklar, topluluklar, hayaller</li>
          <li><strong>12. Ev:</strong> Bilinçaltı, spiritüellik, gizli düşmanlar</li>
        </ul>

        <h2>Aspektler: Gezegenlerin Diyalogu</h2>
        <p>Gezegenler arasındaki açılar (aspektler), enerjilerin nasıl etkileşime girdiğini gösterir. Konjünksiyon, kare, üçgen, karşıt gibi aspektler, kişiliğinizdeki dinamikleri ve yaşam deneyimlerinizi şekillendirir.</p>

        <h2>Doğum Haritanızı Nasıl Kullanabilirsiniz?</h2>
        <p>Doğum haritanız, kendinizi daha iyi anlamanız için güçlü bir araçtır:</p>

        <ul>
          <li>Güçlü yönlerinizi ve yeteneklerinizi keşfedin</li>
          <li>Zorluklarınızı ve büyüme alanlarınızı belirleyin</li>
          <li>İlişkilerinizde daha bilinçli olun</li>
          <li>Kariyer yolunuzu netleştirin</li>
          <li>Yaşam amacınızı anlayın</li>
          <li>Doğru zamanlama için transit ve progresyonları takip edin</li>
        </ul>

        <h2>Profesyonel Bir Okuma Neden Önemli?</h2>
        <p>Doğum haritası karmaşık bir sistemdir ve her sembol, diğerleriyle etkileşim içindedir. Profesyonel bir astrolog, haritanızı bütünsel olarak değerlendirir ve size özel içgörüler sunar. 15 yılı aşkın deneyimimle, doğum haritanızı derinlemesine analiz ediyor ve yaşam yolculuğunuzda size rehberlik ediyorum.</p>

        <p>Doğum haritanız, evrenin size verdiği bir hediyedir. Bu haritayı okumak, kendinizi daha derinden tanımanın ve potansiyelinizi tam olarak yaşamanın anahtarıdır.</p>
      `,
    },
    {
      id: '2',
      category: 'Spiritüel Yaşam',
      title: 'İçsel Huzuru Bulmanın 7 Yolu',
      excerpt: 'Günlük hayatın koşuşturmasında içsel dengenizi korumak için pratik spiritüel uygulamalar.',
      date: '10 Aralık 2024',
      readTime: '7 dk',
      author: 'Deniz Erin',
      image: 'https://readdy.ai/api/search-image?query=serene%20meditation%20scene%20with%20person%20sitting%20in%20peaceful%20lotus%20position%20surrounded%20by%20soft%20golden%20light%20and%20ethereal%20energy%20waves%20on%20calm%20navy%20blue%20background%20spiritual%20wellness%20blog%20image&width=1200&height=600&seq=blogdetail002&orientation=landscape',
      content: `
        <p>Modern yaşamın hızlı temposu içinde içsel huzuru bulmak, çoğumuz için büyük bir meydan okuma haline geldi. Ancak spiritüel uygulamalar, bu huzuru yakalamak ve sürdürmek için güçlü araçlar sunar.</p>

        <h2>1. Günlük Meditasyon Pratiği</h2>
        <p>Meditasyon, zihnin gürültüsünü azaltmanın ve içsel sessizliğe ulaşmanın en etkili yollarından biridir. Günde sadece 10-15 dakika meditasyon yapmak bile, stres seviyenizi düşürebilir ve içsel huzurunuzu artırabilir.</p>

        <p><strong>Nasıl Başlanır:</strong> Rahat bir pozisyonda oturun, gözlerinizi kapatın ve nefesinize odaklanın. Düşünceler geldiğinde onları yargılamadan bırakın ve tekrar nefesinize dönün.</p>

        <h2>2. Nefes Çalışmaları</h2>
        <p>Bilinçli nefes almak, sinir sisteminizi sakinleştirir ve anın farkındalığını artırır. Nefes, bedeniniz ve ruhunuz arasındaki köprüdür.</p>

        <p><strong>4-7-8 Tekniği:</strong> 4 saniye nefes alın, 7 saniye tutun, 8 saniye verin. Bu tekniği günde 3-4 kez tekrarlayın.</p>

        <h2>3. Doğa ile Bağlantı</h2>
        <p>Doğa, en güçlü şifa kaynaklarından biridir. Ağaçların arasında yürümek, deniz kenarında oturmak veya sadece çimlerin üzerinde yalınayak dolaşmak, enerji dengenizi yeniden sağlar.</p>

        <p>Haftada en az bir kez doğada zaman geçirmeye çalışın. Telefonunuzu kapatın ve sadece doğanın seslerini dinleyin.</p>

        <h2>4. Günlük Şükran Pratiği</h2>
        <p>Şükran, içsel huzurun temel taşlarından biridir. Her gün minnettar olduğunuz 3-5 şeyi yazın. Bu basit uygulama, odağınızı eksikliklerden bolluk ve bereket enerjisine kaydırır.</p>

        <p>Sabah uyandığınızda veya gece yatmadan önce şükran listenizi oluşturun. Küçük şeyler bile önemlidir: güneşin ışığı, sıcak bir çay, sevdiklerinizin gülümsemesi...</p>

        <h2>5. Enerji Temizliği</h2>
        <p>Günlük yaşamda birçok negatif enerjiyle karşılaşırız. Düzenli enerji temizliği, bu ağır enerjilerden arınmanıza yardımcı olur.</p>

        <p><strong>Yöntemler:</strong></p>
        <ul>
          <li>Tuz banyoları (Himalaya tuzu veya deniz tuzu)</li>
          <li>Adaçayı veya palo santo tütsüleme</li>
          <li>Beyaz ışık meditasyonu</li>
          <li>Kristal çalışmaları (ametist, kuvars)</li>
        </ul>

        <h2>6. Dijital Detoks</h2>
        <p>Teknoloji bağımlılığı, içsel huzurun en büyük düşmanlarından biridir. Düzenli dijital detoks, zihinsel netliği ve içsel barışı geri getirir.</p>

        <p>Her gün en az 1 saat telefonsuz zaman yaratın. Özellikle yatmadan önce ve uyandıktan sonraki ilk saatte ekranlardan uzak durun.</p>

        <h2>7. Spiritüel Okumalar ve Öğrenme</h2>
        <p>Spiritüel bilgelik, içsel huzurun yolunu aydınlatır. Kitaplar, podcastler veya öğretmenlerden öğrenmek, ruhsal gelişiminizi destekler.</p>

        <p>Her gün 15-20 dakika spiritüel bir kitap okuyun veya ilham verici içerikler dinleyin. Bu, zihninizi yüksek frekanslı enerjilerle besler.</p>

        <h2>Tutarlılık Anahtardır</h2>
        <p>Bu uygulamaların hepsini aynı anda yapmaya çalışmayın. Bir veya iki tanesini seçin ve bunları günlük rutininize entegre edin. Tutarlılık, mucizeler yaratır.</p>

        <p>İçsel huzur, bir varış noktası değil, bir yolculuktur. Her gün küçük adımlar atarak, daha huzurlu ve dengeli bir yaşam yaratabilirsiniz. Bu yolculukta size rehberlik etmek için buradayım.</p>
      `,
    },
    {
      id: '3',
      category: 'Enerji & Şifa',
      title: 'Enerji Dengeleme Nedir ve Nasıl Yapılır?',
      excerpt: 'Bedeninizin ve ruhunuzun enerji akışını dengeleyerek sağlıklı bir yaşam sürdürün.',
      date: '5 Aralık 2024',
      readTime: '6 dk',
      author: 'Deniz Erin',
      image: 'https://readdy.ai/api/search-image?query=healing%20energy%20flow%20visualization%20with%20glowing%20golden%20light%20streams%20and%20chakra%20points%20on%20human%20silhouette%20against%20deep%20navy%20background%20spiritual%20energy%20healing%20concept%20for%20wellness%20blog&width=1200&height=600&seq=blogdetail003&orientation=landscape',
      content: `
        <p>Enerji dengeleme, bedeninizin, zihninizin ve ruhunuzun enerji akışını optimize etme sanatıdır. Her şey enerjidir ve bu enerjinin dengeli akışı, sağlığımızın ve refahımızın temelidir.</p>

        <h2>Enerji Sistemimiz Nasıl Çalışır?</h2>
        <p>İnsan bedeni, karmaşık bir enerji sistemidir. Çakralar, meridyenler ve aura katmanları, bu sistemin temel bileşenleridir. Bu enerji merkezleri ve kanallar, fiziksel, duygusal, zihinsel ve spiritüel sağlığımızı etkiler.</p>

        <h2>7 Ana Çakra</h2>
        <p>Çakralar, bedenimizin enerji merkezleridir. Her biri farklı bir frekansa ve işleve sahiptir:</p>

        <p><strong>1. Kök Çakra (Muladhara):</strong> Güvenlik, hayatta kalma, fiziksel ihtiyaçlar. Renk: Kırmızı. Konum: Kuyruk sokumu.</p>

        <p><strong>2. Sakral Çakra (Svadhisthana):</strong> Yaratıcılık, cinsellik, duygular. Renk: Turuncu. Konum: Göbek altı.</p>

        <p><strong>3. Solar Pleksus Çakra (Manipura):</strong> Güç, özgüven, irade. Renk: Sarı. Konum: Mide bölgesi.</p>

        <p><strong>4. Kalp Çakra (Anahata):</strong> Sevgi, merhamet, bağlantı. Renk: Yeşil/Pembe. Konum: Göğüs merkezi.</p>

        <p><strong>5. Boğaz Çakra (Vishuddha):</strong> İletişim, ifade, hakikat. Renk: Mavi. Konum: Boğaz.</p>

        <p><strong>6. Üçüncü Göz Çakra (Ajna):</strong> Sezgi, içgörü, bilgelik. Renk: İndigo. Konum: Kaşlar arası.</p>

        <p><strong>7. Taç Çakra (Sahasrara):</strong> Spiritüel bağlantı, aydınlanma. Renk: Mor/Beyaz. Konum: Baş üstü.</p>

        <h2>Enerji Dengesizliğinin Belirtileri</h2>
        <p>Enerji dengesizliği, çeşitli fiziksel ve duygusal semptomlara yol açabilir:</p>

        <ul>
          <li>Kronik yorgunluk ve enerji eksikliği</li>
          <li>Duygusal dalgalanmalar ve ruh hali değişimleri</li>
          <li>Fiziksel ağrılar ve rahatsızlıklar</li>
          <li>Uyku problemleri</li>
          <li>Konsantrasyon güçlüğü</li>
          <li>İlişki sorunları</li>
          <li>Motivasyon kaybı</li>
          <li>Kaygı ve stres</li>
        </ul>

        <h2>Enerji Dengeleme Teknikleri</h2>

        <h3>1. Reiki ve Enerji Şifası</h3>
        <p>Reiki, evrensel yaşam enerjisini kullanarak enerji akışını dengeleyen Japon bir şifa tekniğidir. Eller aracılığıyla enerji aktarımı yapılır ve blokajlar temizlenir.</p>

        <h3>2. Kristal Şifa</h3>
        <p>Kristaller, belirli frekanslarda titreşir ve enerji alanımızı etkileyebilir. Her çakra için uygun kristaller kullanılarak denge sağlanır:</p>

        <ul>
          <li>Kök Çakra: Kırmızı jasper, hematit</li>
          <li>Sakral Çakra: Karneol, turuncu kalsit</li>
          <li>Solar Pleksus: Sitrin, sarı jasper</li>
          <li>Kalp Çakra: Yeşil aventurin, gül kuvarsi</li>
          <li>Boğaz Çakra: Mavi akuamarin, lapis lazuli</li>
          <li>Üçüncü Göz: Ametist, sodalit</li>
          <li>Taç Çakra: Berrak kuvars, ametist</li>
        </ul>

        <h3>3. Ses Şifası</h3>
        <p>Ses frekansları, enerji alanımızı doğrudan etkiler. Tibetan çanları, kristal kaseler, mantralar ve müzik terapi, enerji dengeleme için kullanılır.</p>

        <h3>4. Aromaterapi</h3>
        <p>Esansiyel yağlar, enerji merkezlerimizi etkileyebilir. Her çakra için uygun yağlar:</p>

        <ul>
          <li>Kök: Paçuli, vetiver</li>
          <li>Sakral: Portakal, ylang ylang</li>
          <li>Solar Pleksus: Limon, zencefil</li>
          <li>Kalp: Gül, bergamot</li>
          <li>Boğaz: Nane, okaliptüs</li>
          <li>Üçüncü Göz: Lavanta, biberiye</li>
          <li>Taç: Tütsü, lotus</li>
        </ul>

        <h3>5. Yoga ve Hareket</h3>
        <p>Fiziksel hareket, enerji akışını destekler. Yoga pozları, özellikle çakra açıcı asanalar, enerji dengeleme için mükemmeldir.</p>

        <h2>Günlük Enerji Dengeleme Rutini</h2>

        <p><strong>Sabah:</strong></p>
        <ul>
          <li>5 dakika çakra meditasyonu</li>
          <li>Nefes çalışması (pranayama)</li>
          <li>Hafif esneme veya yoga</li>
        </ul>

        <p><strong>Gün İçinde:</strong></p>
        <ul>
          <li>Düzenli su içme (enerji akışını destekler)</li>
          <li>Kısa nefes molaları</li>
          <li>Doğa ile temas</li>
        </ul>

        <p><strong>Akşam:</strong></p>
        <ul>
          <li>Tuz banyosu veya duş</li>
          <li>Kristal meditasyonu</li>
          <li>Günlük enerji temizliği</li>
        </ul>

        <h2>Profesyonel Enerji Şifası</h2>
        <p>Kendi kendinize yapabileceğiniz uygulamalar çok değerli olsa da, derin blokajlar ve kronik dengesizlikler için profesyonel bir enerji şifacısıyla çalışmak önemlidir.</p>

        <p>15 yılı aşkın deneyimimle, enerji alanınızı tarayıp blokajları tespit ediyor ve size özel şifa seansları sunuyorum. Reiki, kristal şifa ve diğer enerji dengeleme tekniklerini birleştirerek, bütünsel bir şifa deneyimi yaratıyorum.</p>

        <p>Enerji dengeleme, bir yaşam tarzıdır. Düzenli uygulama ile, daha sağlıklı, mutlu ve dengeli bir yaşam yaratabilirsiniz.</p>
      `,
    },
  ];

  const currentPost = blogPosts.find(post => post.id === id);

  if (!currentPost) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="max-w-4xl mx-auto px-6 py-32 text-center">
          <h1 className="text-4xl font-bold text-primary-dark mb-4">Blog yazısı bulunamadı</h1>
          <Link to="/blog" className="text-gold hover:underline cursor-pointer">
            Blog sayfasına dön
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  // Diğer blog yazıları (ilgili içerik)
  const relatedPosts = blogPosts.filter(post => post.id !== id).slice(0, 2);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Image */}
      <div className="relative w-full h-[500px] overflow-hidden">
        <img
          src={currentPost.image}
          alt={currentPost.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        
        {/* Category Badge */}
        <div className="absolute top-8 left-1/2 transform -translate-x-1/2">
          <span className="px-6 py-2 bg-gold text-primary-dark text-sm font-bold rounded-full">
            {currentPost.category}
          </span>
        </div>
      </div>

      {/* Article Content */}
      <article className="max-w-4xl mx-auto px-6 -mt-32 relative z-10">
        {/* Title Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 mb-12"
        >
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary-dark mb-6 leading-tight">
            {currentPost.title}
          </h1>

          {/* Meta Info */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-text-secondary pb-8 border-b border-gray-200">
            <div className="flex items-center space-x-2">
              <i className="ri-user-line text-gold"></i>
              <span>{currentPost.author}</span>
            </div>
            <span>•</span>
            <div className="flex items-center space-x-2">
              <i className="ri-calendar-line text-gold"></i>
              <span>{currentPost.date}</span>
            </div>
            <span>•</span>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-gold"></i>
              <span>{currentPost.readTime} okuma</span>
            </div>
          </div>

          {/* Article Body */}
          <div 
            className="prose prose-lg max-w-none mt-8"
            style={{
              color: '#2C3E50',
              lineHeight: '1.8',
            }}
            dangerouslySetInnerHTML={{ __html: currentPost.content }}
          />

          {/* Share Buttons */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm font-semibold text-primary-dark mb-4">Bu yazıyı paylaş:</p>
            <div className="flex items-center space-x-4">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-[#1877F2] text-white rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="Facebook'ta Paylaş"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${window.location.href}&text=${currentPost.title}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-[#1DA1F2] text-white rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="Twitter'da Paylaş"
              >
                <i className="ri-twitter-fill"></i>
              </a>
              <a
                href={`https://wa.me/?text=${currentPost.title} ${window.location.href}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="WhatsApp'ta Paylaş"
              >
                <i className="ri-whatsapp-fill"></i>
              </a>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  alert('Link kopyalandı!');
                }}
                className="w-10 h-10 flex items-center justify-center bg-gray-600 text-white rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="Linki Kopyala"
              >
                <i className="ri-link"></i>
              </button>
            </div>
          </div>
        </motion.div>

        {/* Author Bio */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-cream to-white rounded-3xl shadow-xl p-8 mb-12"
        >
          <div className="flex items-start space-x-6">
            <div className="w-24 h-24 rounded-full overflow-hidden flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/0c15e7412b31ca3745e64ac30f83ca52.png"
                alt="Deniz Erin"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h3 className="font-serif text-2xl font-bold text-primary-dark mb-2">
                Deniz Erin
              </h3>
              <p className="text-text-secondary leading-relaxed mb-4">
                15 yılı aşkın deneyime sahip profesyonel astrolog ve spiritüel danışman. 
                Astrolojik danışmanlık, enerji şifası ve spiritüel rehberlik alanlarında 
                binlerce kişiye yol göstermiştir.
              </p>
              <Link
                to="/hakkimda"
                className="inline-flex items-center text-gold font-medium hover:gap-2 transition-all duration-300 cursor-pointer"
              >
                <span>Daha Fazla Bilgi</span>
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          </div>
        </motion.div>

        {/* Related Posts */}
        {relatedPosts.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-16"
          >
            <h2 className="font-serif text-3xl font-bold text-primary-dark mb-8">
              İlgili Yazılar
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {relatedPosts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-2xl mb-4">
                    <div className="w-full h-64">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                      />
                    </div>
                    <div className="absolute top-4 left-4">
                      <span className="px-4 py-2 bg-gold text-primary-dark text-xs font-bold rounded-full">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  <h3 className="font-serif text-xl font-bold text-primary-dark mb-2 group-hover:text-gold transition-colors duration-300">
                    {post.title}
                  </h3>
                  <p className="text-text-secondary text-sm line-clamp-2">
                    {post.excerpt}
                  </p>
                </Link>
              ))}
            </div>
          </motion.div>
        )}

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-primary-dark to-[#1a2332] rounded-3xl shadow-2xl p-12 text-center mb-16"
        >
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Kişisel Danışmanlık Almak İster Misiniz?
          </h2>
          <p className="text-cream text-lg mb-8 max-w-2xl mx-auto">
            Size özel astrolojik danışmanlık ve spiritüel rehberlik için randevu alın.
          </p>
          <Link
            to="/randevu"
            className="inline-block px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Hemen Randevu Al
          </Link>
        </motion.div>
      </article>

      <Footer />

      {/* Custom Styles for Article Content */}
      <style>{`
        .prose h2 {
          font-family: 'Playfair Display', serif;
          font-size: 1.875rem;
          font-weight: 700;
          color: #1F2937;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
        }
        .prose h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          font-weight: 600;
          color: #1F2937;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
        }
        .prose p {
          margin-bottom: 1.5rem;
        }
        .prose strong {
          color: #D4AF37;
          font-weight: 600;
        }
        .prose ul {
          list-style-type: disc;
          padding-left: 1.5rem;
          margin-bottom: 1.5rem;
        }
        .prose li {
          margin-bottom: 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default BlogDetailPage;